import { TenantPolicyResponse, TenantResponse, TenantStatsResponse, TenantThemeResponse } from './tenant.response';
import { TenantPolicyState, TenantState, TenantStatsState, TenantThemeState } from './tenant.state';

/** Pure wire → state mappers for the tenant endpoints (no date fields). */

export function mapTenantThemeResponse(response: TenantThemeResponse): TenantThemeState {
  return {
    ...response,
    defaultLocation: response.defaultLocation ? { ...response.defaultLocation } : null
  };
}

export function mapTenantStatsResponse(response: TenantStatsResponse): TenantStatsState {
  return { ...response };
}

export function mapTenantPolicyResponse(response: TenantPolicyResponse): TenantPolicyState {
  return { ...response };
}

export function mapTenantResponse(response: TenantResponse): TenantState {
  return {
    ...response,
    theme: mapTenantThemeResponse(response.theme),
    stats: mapTenantStatsResponse(response.stats),
    policy: mapTenantPolicyResponse(response.policy)
  };
}
